// src/hooks/usePitchReels.js
import { useQueryClient } from '@tanstack/react-query';
import { FetchPitchReels, HandlePitchReelAction } from 'api/pitch-reels';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePitchReels = (
  investor_id,
  viewType = 'preference',
  selectedStartupId,
  setSelectedStartupId
) => {
  const queryClient = useQueryClient();
  const [searchParams, setSearchParams] = useSearchParams();

  // FIX: Proper query key construction
  const queryKey = ['pitch-reels', investor_id, viewType, selectedStartupId].filter(Boolean);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
    error,
    refetch,
  } = FetchPitchReels({
    investor_id,
    viewType,
    enabled: true,
    selectedStartupId,
    setSelectedStartupId,
    setSearchParams
  });

  const actionMutation = HandlePitchReelAction();

  const handleAction = async (startupId, action, options = {}) => {
    // Use the properly constructed query key
    try {
      await actionMutation.mutateAsync(
        { startupId, action, investorId: investor_id },
        {
          onMutate: async () => {
            await queryClient.cancelQueries({ queryKey });
            const previousData = queryClient.getQueryData(queryKey);

            queryClient.setQueryData(queryKey, (oldData) => {
              if (!oldData) return oldData;

              const updatedPages = oldData.pages?.map((page) => {
                const updatedVideos = page.data?.videos
                  ?.map((video) => {
                    if (video.startupId === startupId || video._id === startupId) {
                      return {
                        ...video,
                        action: action,
                        isLiked: action === 'like',
                        isPassed: action === 'dislike'
                      };
                    }
                    return video;
                  })
                  // .filter((video) => {
                  //   // IMPORTANT: Don't filter when selectedStartupId is present
                  //   if (selectedStartupId) {
                  //     return true; // Keep all videos when viewing a specific startup
                  //   }

                  //   if (viewType === 'preference' && (action === 'like' || action === 'dislike')) {
                  //     return !(video.startupId === startupId || video._id === startupId);
                  //   }
                  //   if (viewType === 'dealflow' && action === 'dislike') {
                  //     return !(video.startupId === startupId || video._id === startupId);
                  //   }
                  //   return true;
                  // });

                return {
                  ...page,
                  data: {
                    ...page.data,
                    videos: updatedVideos,
                    total: updatedVideos.length,
                  }
                };
              });

              return {
                ...oldData,
                pages: updatedPages,
                pageParams: oldData.pageParams,
              };
            });

            return { previousData };
          },
          onError: (error, variables, context) => {
            if (context?.previousData) {
              queryClient.setQueryData(queryKey, context.previousData);
            }
            console.error('Action failed, rolled back:', error);
            options.onError?.(error);
          },
          onSuccess: () => {
            options.onSuccess?.();
          },
          // onSettled: () => {
          //   // Invalidate all pitch-reels queries
          //   queryClient.invalidateQueries({
          //     queryKey: ['pitch-reels', investor_id],
          //   });

          //   options.onSettled?.();
          // },
        }
      );
    } catch (error) {
      console.error('Action error:', error);
    }
  };

  const videos = data?.pages?.flatMap((page) => page?.data?.videos) || [];
  const total = data?.pages?.[0]?.data?.total || 0;
  const hasMore = data?.pages?.[data?.pages?.length - 1]?.data?.hasMore || false;

  return {
    videos,
    total,
    hasMore,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
    error,
    refetch,
    handleAction,
    isActionLoading: actionMutation.isPending,
  };
};
